import { doc, onSnapshot } from 'firebase/firestore';
import {
  CaptureResult,
  firestorePaths,
  parseCaptureStatusDocument,
} from '@qkindex/contracts';
import { db } from '../firebase';

interface CaptureIdentity {
  userId: string;
  collectionId: string;
  operationId: string;
  membershipVersion: number;
  itemId: string;
}

export const subscribeToCaptureStatus = (
  identity: CaptureIdentity,
  next: (receipt: CaptureResult) => void,
  error: () => void,
): (() => void) =>
  onSnapshot(
    doc(
      db,
      firestorePaths.captureStatus(identity.collectionId, identity.operationId),
    ),
    { includeMetadataChanges: true },
    (snapshot) => {
      if (snapshot.metadata.fromCache || snapshot.metadata.hasPendingWrites)
        return;
      try {
        if (!snapshot.exists()) {
          error();
          return;
        }
        const status = parseCaptureStatusDocument(snapshot.data());
        if (
          status.actorUserId !== identity.userId ||
          status.collectionId !== identity.collectionId ||
          status.operationId !== identity.operationId ||
          status.expectedMembershipVersion !== identity.membershipVersion ||
          (status.itemId !== undefined && status.itemId !== identity.itemId)
        )
          throw new Error('Capture status scope changed.');
        if (status.state === 'uploading') return;
        next({
          state: status.state,
          revision: status.revision,
          mode: status.mode,
          ...(status.itemId === undefined
            ? {}
            : {
                itemId: status.itemId,
                analysisComplete: status.analysisComplete,
              }),
          ...(status.errorCode ? { errorCode: status.errorCode } : {}),
          ...(status.aiSettlement ? { aiSettlement: status.aiSettlement } : {}),
        });
      } catch {
        error();
      }
    },
    error,
  );
